import React from "react";

export default function Atrium() {
  return (
    <>
      {/* <Header /> */}
    </>
  );
}
